"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortedBorrows__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_id",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_NICR",
                type: "uint256",
            },
        ],
        name: "NodeAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_id",
                type: "address",
            },
        ],
        name: "NodeRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "NAME",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "_id",
                type: "address",
            },
        ],
        name: "contains",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "data",
        outputs: [
            {
                internalType: "address",
                name: "head",
                type: "address",
            },
            {
                internalType: "address",
                name: "tail",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "size",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_NBB",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_prevId",
                type: "address",
            },
            {
                internalType: "address",
                name: "_nextId",
                type: "address",
            },
        ],
        name: "findInsertPosition",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
        ],
        name: "getFirst",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
        ],
        name: "getLast",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "_id",
                type: "address",
            },
        ],
        name: "getNext",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "_id",
                type: "address",
            },
        ],
        name: "getPrev",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
        ],
        name: "getSize",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_admin",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "_id",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_NBB",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_prevId",
                type: "address",
            },
            {
                internalType: "address",
                name: "_nextId",
                type: "address",
            },
        ],
        name: "insert",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
        ],
        name: "isEmpty",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isSortedBorrows",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "_id",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_newNBB",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_prevId",
                type: "address",
            },
            {
                internalType: "address",
                name: "_nextId",
                type: "address",
            },
        ],
        name: "reInsert",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "redemptionManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                internalType: "address",
                name: "_id",
                type: "address",
            },
        ],
        name: "remove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_redemptionManager",
                type: "address",
            },
        ],
        name: "setRedemptionManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_asset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_NBB",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_prevId",
                type: "address",
            },
            {
                internalType: "address",
                name: "_nextId",
                type: "address",
            },
        ],
        name: "validInsertPosition",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SortedBorrows__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.SortedBorrows__factory = SortedBorrows__factory;
SortedBorrows__factory.bytecode = _bytecode;
SortedBorrows__factory.abi = _abi;
//# sourceMappingURL=SortedBorrows__factory.js.map